// TabBadge — "n 🟢  m 🔴" chip that renders next to Reception & Prenotazioni
// tab labels showing pending arrivals (sage) and pending departures
// (destructive) for TODAY. Fed by GET /reception/today-counts, refreshed
// every 60s by the parent Dashboard.
// Extracted from Dashboard.jsx (Iter 92) — component is stateless and
// safe to move as-is.
export default function TabBadge({ counts }) {
  const arr = Number(counts?.arrivals_pending) || 0;
  const dep = Number(counts?.departures_pending) || 0;
  if (!arr && !dep) return null;
  return (
    <span className="ml-1.5 inline-flex items-center gap-1" data-testid="tab-badge">
      {arr > 0 && (
        <span
          className="inline-flex items-center gap-0.5 text-[10px] font-semibold text-sage bg-sage/15 border border-sage/40 rounded-full px-1.5 leading-4 whitespace-nowrap"
          title={`${arr} in arrivo oggi`}
          data-testid="tab-badge-arrivals"
        >
          <span className="w-1.5 h-1.5 rounded-full bg-sage inline-block"/>
          {arr}
        </span>
      )}
      {dep > 0 && (
        <span
          className="inline-flex items-center gap-0.5 text-[10px] font-semibold text-destructive bg-destructive/10 border border-destructive/40 rounded-full px-1.5 leading-4 whitespace-nowrap"
          title={`${dep} in partenza oggi`}
          data-testid="tab-badge-departures"
        >
          <span className="w-1.5 h-1.5 rounded-full bg-destructive inline-block"/>
          {dep}
        </span>
      )}
    </span>
  );
}
